export const costCategories = {
  validation: { label: "妥当性確認", description: "" },
  monitoring: {
    label: "モニタリング",
    description: "継続的なプロジェクト監視の年間コスト",
  },
  verification: {
    label: "検証",
    description: "定期的な検証コスト",
  },
  issuance: {
    label: "発行",
    description: "クレジット発行に関連するコスト",
  },
  community: {
    label: "追加のコミュニティ活動",
    description:
      "任意のコミュニティ参加、FPIC、セーフガードなど、直接給付以外の活動費",
  },
};

export const costItems = {
  activity_community_patrols: "コミュニティパトロール",
  activity_satellite_monitoring: "衛星モニタリング",
  activity_reforestation_site_prep: "再森林化の用地準備",
  activity_reforestation_planting: "再森林化の植栽",
  activity_reforestation_nursery: "再森林化の苗畑",
  activity_reforestation_maintenance: "再森林化の維持管理",
  activity_firebreak_site_prep: "防火帯 / 用地準備",
  vvb_validation: "VVB妥当性確認",
  vvb_verification: "VVB検証",
  remote_sensing: "リモートセンシング",
  mrv_report_prep: "MRVレポート作成",
  field_ops: "現地作業",
  field_travel: "現地移動",
  plot_establishment: "調査区設置",
  plot_remeasurement: "調査区再測定",
  tree_measurement: "樹木測定",
  legal_admin: "法務・管理",
  community_engagement: "コミュニティ参加・FPIC実施費",
  buffer_withholding: "バッファ控除",
  working_capital_carry: "運転資本コスト",
  redd_vvb_validation: "REDD+ VVB妥当性確認",
  redd_vvb_verification: "REDD+ VVB検証",
  arr_vvb_validation: "ARR VVB妥当性確認",
  arr_vvb_verification: "ARR VVB検証",
  preliminary_ghg_quantification: "予備GHG定量化",
  certification_fee_under_10k_ha: "10,000 ha未満の認証手数料",
  certification_fee_10k_to_100k_ha: "10,000から100,000 haの認証手数料",
  certification_fee_over_100k_ha: "100,000 ha超の認証手数料",
  validation_vvb_fee: "VVB妥当性確認手数料",
  mrv_tiered: "MRV手数料",
  verification_vvb_fee: "VVB検証手数料",
  project_expansion_fee: "プロジェクト拡張手数料",
  preliminary_ghg_baseline_assessment: "予備GHGベースライン評価",
  feasibility_assessment: "実現可能性評価",
  design_review: "設計レビュー",
  plan_vivo_pin_fee: "Plan Vivo PIN手数料",
  plan_vivo_pdd_fee_macro: "Plan Vivo PDD手数料",
  acceptance_criteria_validation_base: "受入基準の妥当性確認基本費",
  acceptance_criteria_validation_per_property:
    "受入基準の妥当性確認（物件ごと）",
  acceptance_criteria_verification_base: "受入基準の検証基本費",
  acceptance_criteria_verification_per_property:
    "受入基準の検証（物件ごと）",
  account_annual: "年間アカウント手数料",
  account_open: "アカウント開設手数料",
  account_registration: "アカウント登録",
  activation_fee: "有効化手数料",
  art_registry_account_annual: "ARTレジストリ年間アカウント手数料",
  art_trees_issuance_fee: "ART TREES発行手数料",
  baseline_study: "ベースライン調査",
  baseline_study_core: "ベースライン調査コア",
  benefit_admin: "便益管理",
  custodial_annual: "年間カストディ手数料",
  data_platform: "データプラットフォーム",
  data_processing: "データ処理",
  drone_capex: "ドローン機材",
  drone_depreciation: "ドローン減価償却",
  equitable_earth_design_review_base:
    "Equitable Earth設計レビュー基本費",
  equitable_earth_design_review_per_ha:
    "Equitable Earth設計レビュー（haあたり）",
  equitable_earth_design_review_per_ha_raw:
    "Equitable Earth設計レビュー（haあたり）",
  equitable_earth_feasibility_review_base:
    "Equitable Earth実現可能性レビュー基本費",
  equitable_earth_feasibility_review_per_ha:
    "Equitable Earth実現可能性レビュー（haあたり）",
  equitable_earth_feasibility_review_per_ha_raw:
    "Equitable Earth実現可能性レビュー（haあたり）",
  equitable_earth_monitoring_reporting_base_annual:
    "Equitable Earth年間モニタリング・報告基本費",
  equitable_earth_monitoring_reporting_per_ha_annual:
    "Equitable Earth年間モニタリング・報告（haあたり）",
  equitable_earth_preliminary_ghg_assessment:
    "Equitable Earth予備GHG評価",
  extension_support: "普及支援",
  farmer_enrollment: "農家登録",
  fpic_consultation: "FPIC協議",
  gcc_issuance_fee: "GCC発行手数料",
  gcc_project_registration: "GCCプロジェクト登録",
  gcc_transaction_registry_account_open:
    "GCC取引レジストリアカウント開設",
  gcc_transaction_registry_annual: "GCC取引レジストリ年間手数料",
  insurance: "保険",
  inventory_completion: "インベントリ完了",
  inventory_completion_core: "インベントリ完了コア",
  inventory_core: "インベントリコア",
  issuance_fee_sop_cash: "SOP現金発行手数料",
  lca_modeling: "LCAモデリング",
  leakage_analysis: "リーケージ分析",
  listing_review: "リスティングレビュー",
  metering_pack: "計測パッケージ",
  monitoring_drone: "モニタリング用ドローン",
  nursery_opex: "苗畑運営",
  output_audit: "成果監査",
  pada_fee: "PADA手数料",
  pada_linear: "PADA面積比例手数料",
  parcel_mapping: "区画マッピング",
  per_credit_monitoring: "クレジット単位モニタリング",
  performance_review: "パフォーマンスレビュー",
  pipeline_listing: "パイプライン掲載",
  planting: "植栽",
  pooling_fee: "プーリング手数料",
  preliminary_review: "予備レビュー",
  registration_review: "登録レビュー",
  registry_annual: "年間レジストリ手数料",
  requantification_transition: "再定量化移行",
  retirement_fee: "償却手数料",
  royalty_fee: "ロイヤルティ手数料",
  sampling: "サンプリング",
  sensor_calibration: "センサー校正",
  sensor_capex: "センサー機材",
  sensor_depreciation: "センサー減価償却",
  sensor_package: "センサーパッケージ",
  share_of_proceeds: "収益分配",
  site_maintenance: "サイト維持管理",
  site_prep: "サイト準備",
  social_carbon_issuance_fee: "SOCIALCARBON発行手数料",
  social_carbon_project_design_review:
    "SOCIALCARBONプロジェクト設計レビュー",
  social_carbon_registration_review: "SOCIALCARBON登録レビュー",
  stock_change_review: "炭素蓄積変化レビュー",
  survival_sampling: "活着率サンプリング",
  validation_review: "妥当性確認レビュー",
  vcu_issuance_levy: "VCU発行賦課金",
  verification_fee_base: "検証手数料基本費",
  verification_fee_per_site: "検証手数料（サイトごと）",
  verification_review: "検証レビュー",
};

export const costItemNotes = {
  redd_vvb_validation:
    "推定値は市場レンジ [V3][V4] を使用しています。最終金額にはVVB見積もりが必要です。",
  redd_vvb_verification:
    "推定値は市場レンジ [V3][V4] を使用しています。最終金額にはVVB見積もりが必要です。",
  arr_vvb_validation:
    "推定値は市場レンジ [V3][V4] を使用しています。最終金額にはVVB見積もりが必要です。",
  arr_vvb_verification:
    "推定値は市場レンジ [V3][V4] を使用しています。最終金額にはVVB見積もりが必要です。",
  preliminary_ghg_quantification:
    "予備GHGポテンシャル定量化の受領後に支払われます。",
  certification_fee_under_10k_ha: "10,000 ha未満のプロジェクト。",
  certification_fee_10k_to_100k_ha: "10,000 haから100,000 haのプロジェクト。",
  certification_fee_over_100k_ha: "100,000 ha超のプロジェクト。",
  validation_vvb_fee:
    "Equitable Earthが支払い、契約署名時に開発者へ再請求します。",
  mrv_tiered: "毎年、年初に支払われます。",
  verification_vvb_fee: "各検証監査時に再請求されます。",
  project_expansion_fee: "適応管理期間外の拡張ごとに適用されます。",
  preliminary_ghg_baseline_assessment: "グループ2の手順。",
  feasibility_assessment: "グループ2の手順。",
  design_review: "グループ2の手順。",
};
